import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';

// @mui
import { Link, Stack, IconButton, InputAdornment, TextField, Checkbox } from '@mui/material';
import { LoadingButton } from '@mui/lab';

// components
import Iconify from '../../../components/iconify';
import api from 'src/api';
import { loadingStartAction, loadingStopAction } from 'src/redux/actions/loadingActions';

// ----------------------------------------------------------------------

export default function AdminChangePassword() {
  const dispatch = useDispatch();

  const [oldPassword, setOldPassword] = useState('');
  const [password, setPassword] = useState('');
  const [cPassword, setCPassword] = useState('');

  const changePassword = async () => {
    if (!oldPassword || !password || !cPassword) {
      alert("All Fields Are Required!'");
      return;
    }

    if (password !== cPassword) {
      alert('New password does not match!');
      return;
    }

    let reqBody = {
      oldPassword,
      newPassword: password,
    };

    dispatch(loadingStartAction());

    let res = await api.put('users/password-change', reqBody);
    dispatch(loadingStopAction());
  };

  return (
    <>
      <Stack spacing={3}>
        <TextField
          name="old-pas"
          label="Old Password"
          value={oldPassword}
          onChange={(e) => setOldPassword(e.target.value)}
        />
        <TextField name="new_psa" label="New Password" value={password} onChange={(e) => setPassword(e.target.value)} />
        <TextField
          name="c_new_psa"
          label="Confirm New Password"
          value={cPassword}
          onChange={(e) => setCPassword(e.target.value)}
        />
      </Stack>
      <br />
      <LoadingButton fullWidth size="large" type="submit" variant="contained" onClick={changePassword}>
        CONFIRM
      </LoadingButton>
    </>
  );
}
